export default __webpack_public_path__ + "static/media/iconfont.d2189698.woff";